import './versionmodel'
import './versioncollection'
import './versionstabview'
import './filesplugin'
import './css/versions.css'

window.OCA.Versions = OCA.Versions
